// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import styled from 'styled-components';
import Column from './Column';
import Icon from './Icon';
import RemarkText from './typography/RemarkText';

interface Props {
  active?: boolean;
  icon: string;
  activeIcon?: string;
  text: string;
}

const S = {
  Icon: styled(Icon)<{ show?: boolean }>`
  ${(props) => !props.show ? { display: 'none' } : null }
`,
  RemarkText: styled.p<{ active?: boolean }>`
    margin-top: 4px;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: ${props => props.active ? 'white' : '#C9C9C9'};
  `,
}

export default styled(({ icon, active, activeIcon, text, className, ...props }: Props & React.ComponentPropsWithoutRef<any>) => {
  return (
    <Column alignX="center" className={className} {...props}>
      <S.Icon icon={icon} show={!active} />
      <S.Icon icon={activeIcon || icon} show={active} />
      <S.RemarkText active={active}>{text}</S.RemarkText>
    </Column>
  )
})`
`
